import React, { useContext } from 'react';
import { LayoutContext } from './Context/LayoutContext';
import CMS_Setting from './Views/CMSSetting/CMS-Setting';
const Login = React.lazy(() => import('./Views/Login/Login'));
const ForgotPassword = React.lazy(() => import('./Views/Login/ForgotPassword'));
const ResetPassword = React.lazy(() => import('./Views/Login/ResetPassword'));
const Dashboard = React.lazy(() => import('./Views/Dashboard/Index'));
const EmployeeDashboard = React.lazy(() => import('./Views/Dashboard/EmployeeDashboard'));
const ExternalDashboard = React.lazy(() => import('./Views/ExternalSme/ExternalDashboard'));
const Calender = React.lazy(() => import('./Views/Calender/Calender'));
const Leave = React.lazy(() => import('./Views/Leave/Index'));
const AttendanceRequest = React.lazy(() => import('./Views/Leave/AttendanceRequest'));
const EmployeeList = React.lazy(() => import('./Views/Employee/EmpoyeeList'));
const EmployeeAdd = React.lazy(() => import('./Views/Employee/Add'));
const EmployeeView = React.lazy(() => import('./Views/Employee/EmployeeView'));
const OnBoarding = React.lazy(() => import('./Views/OnBoarding/OnBoarding'));
const OnBoardingResume = React.lazy(() => import('./Views/OnBoarding/OnBoardingResume'));
const ResumeList = React.lazy(() => import('./Views/Resume/ResumeList'));
const InterviewPipeline = React.lazy(() => import('./Views/InterviewPipeline/InterviewPipeline'));
const Interview = React.lazy(() => import('./Views/Interview/Interview'));
const Setting = React.lazy(() => import('./Views/Setting/Index'));
const Reports = React.lazy(() => import('./Views/Reports/Index'));
const JobPost = React.lazy(() => import('./Views/JobPost/JobPost'));
const JobList = React.lazy(() => import('./Views/JobPost/JobList'));
const JobPostDetail = React.lazy(() => import('./Views/JobPost/JobPostDetail'));
const ExternalSME = React.lazy(() => import('./Views/JobPost/ExternalSME'));
const ExternalSMEList = React.lazy(() => import('./Views/JobPost/ExternalSMEList'));
const ExternalSMEDetail = React.lazy(() => import('./Views/JobPost/ExternalSMEDetail'));
const InterviewList = React.lazy(() => import('./Views/Interview/Employee/Interview-List'));
const useRoleBasedRoutes = () => {
  const { currentUserRole } = useContext(LayoutContext);

  // Define routes
  const routes = [
    { path: '/', exact: true, name: 'Login', element: Login },
    {
      path: '/forgot-password',
      exact: true,
      name: 'Forgot Password',
      element: ForgotPassword,
    },
    {
      path: '/reset-password',
      exact: true,
      name: 'Reset Password',
      element: ResetPassword,
    },
    { path: '/calender', exact: true, name: 'Calender', element: Calender },
    { path: '/leave', exact: true, name: 'Leave', element: Leave },
    {
      path: '/attendance-request',
      exact: true,
      name: 'Leave',
      element: AttendanceRequest,
    },
    // Adjust the dashboard route based on role
    {
      path: '/dashboard',
      exact: true,
      name: 'Dashboard',
      element: currentUserRole === 1 ? Dashboard : EmployeeDashboard,
    },
    {
      path: '/dashboardExternal',
      exact: true,
      name: 'External Dashboard',
      element: ExternalDashboard,
    },
    {
      path: '/employees',
      exact: true,
      name: 'Employees',
      element: EmployeeList,
    },
    {
      path: '/employees/add',
      exact: true,
      name: 'Employee Add',
      element: EmployeeAdd,
    },
    {
      path: '/employees/edit',
      exact: true,
      name: 'Employee Edit',
      element: EmployeeAdd,
    },
    {
      path: '/employees/:EmployeeID',
      exact: true,
      name: 'Employees View',
      element: EmployeeView,
    },
    {
      path: '/onboarding',
      exact: true,
      name: 'On Boarding',
      element: OnBoarding,
    },
    {
      path: '/ResumeList',
      exact: true,
      name: 'Resume List',
      element: ResumeList,
    },
    {
      path: '/InterviewPipeline',
      exact: true,
      name: 'Interview Pipeline',
      element: InterviewPipeline,
    },
    //
    {
      path: '/onboarding/:onBoardingId',
      exact: true,
      name: 'onboarding resume',
      element: OnBoardingResume,
    },
    {
      path: '/interview/:id',
      exact: true,
      name: 'interview',
      element: Interview,
    },
    {
      path: '/setting',
      exact: true,
      name: 'Setting',
      element: Setting,
    },
    {
      path: '/reports',
      exact: true,
      name: 'Reports',
      element: Reports,
    },
    {
      path: '/JobPost',
      exact: true,
      name: 'Job Post',
      element: JobPost,
    },
    {
      path: '/JobList',
      exact: true,
      name: 'Job List',
      element: JobList,
    },
    {
      path: '/JobPost/:jobPostId',
      exact: true,
      name: 'Job Post Detail',
      element: JobPostDetail,
    },
    {
      path: '/JobPost/:jobPostId/edit',
      exact: true,
      name: 'Job Post Detail Edit',
      element: JobPost,
    },
    {
      path: '/externalSME',
      exact: true,
      name: 'External SME',
      element: ExternalSME,
    },
    {
      path: '/externalSMEList',
      exact: true,
      name: 'External SME List',
      element: ExternalSMEList,
    },
    {
      path: '/externalSME/:smeId',
      exact: true,
      name: 'External SME Detail',
      element: ExternalSMEDetail,
    },
    {
      path: '/externalSME/:smeId/edit',
      exact: true,
      name: 'External SME Detail Edit',
      element: ExternalSME,
    },
    {
      path: '/interview/list',
      exact: true,
      name: 'Interview List',
      element: InterviewList,
    },
    {
      path: '/cms-setting',
      exact: true,
      name: 'CMS Setting',
      element: CMS_Setting,
    },
  ];

  return routes;
};

export default useRoleBasedRoutes;
